const {
  REACT_APP_SPOTIFY_ARTIST_URL,
  REACT_APP_YOUTUBE_CHANNEL_URL,
  REACT_APP_INSTAGRAM_PAGE_URL,
} = process.env;

export const openInNewTab = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer");
};

export const onClickSpotify = (spotifyId: string) => {
  if (spotifyId) {
    openInNewTab(`${REACT_APP_SPOTIFY_ARTIST_URL}${spotifyId}`);
  }
};

export const onClickYoutube = (channelIdYoutube: string) => {
  if (channelIdYoutube)
    openInNewTab(`${REACT_APP_YOUTUBE_CHANNEL_URL}${channelIdYoutube}`);
};

export const onClickInstagram = (usernameInstagram: string) => {
  if (usernameInstagram)
    openInNewTab(`${REACT_APP_INSTAGRAM_PAGE_URL}${usernameInstagram}`);
};
